import ProductDivisionPage from './ProductDivisionPage';

export default ProductDivisionPage;
